import React, { forwardRef } from "react"
import PropTypes from "prop-types"
import { useTheme } from "styled-components"

import { MfButton } from "."
import { useMatchMedia } from "../../helpers/useMatchMedia"

export const MfCollapsableButton = forwardRef(
  ({ expandFrom = "tablet", text = false, children, ...props }, ref) => {
    const theme = useTheme()
    const showFullButtons = useMatchMedia(theme.screen.size[expandFrom] || expandFrom)

    return (
      <MfButton {...props} ref={ref} text={showFullButtons ? text : true}>
        {showFullButtons ? children : null}
      </MfButton>
    )
  }
)

MfCollapsableButton.displayName = "MfCollapsableButton"

MfCollapsableButton.propTypes = {
  expandFrom: PropTypes.string,
  text: PropTypes.bool,
  children: PropTypes.any.isRequired,
}
